/**
 * Centralized company information for Settlin
 * This file serves as the single source of truth for all company-related data
 * including contact details, addresses, social media links, and legal information.
 */

export const COMPANY_INFO = {
	// Basic Company Information
	name: "Settlin",
	legalName: "Linking Spaces Technologies Pvt. Ltd.",
	tagline: "Buy/Sell Flats, Villas, Houses from the best broker in Bangalore",
	// shortDescription: "Search, Visit, Check Legal, Negotiate and Buy - all at one place.",
	// buyerDescription:
	// "Do not just search, but request visits on properties that you like and get assistance on negotiations, price trends, legal, and even loan - all for a minimal service fee. Apartments, Villas and Houses for Sale in Bangalore",
	description:
		"India's leading real estate platform for buying and selling properties in Bangalore. Expert guidance, genuine buyers, and end-to-end assistance.",
	foundingDate: "2016-01-29",
	website: "https://settlin.in",

	// Contact Information
	contact: {
		email: {
			primary: "hello@settlin.in",
			careers: "career+webapp@settlin.in",
		},
		phone: {
			primary: "+91-95-9003-9003",
			formatted: "+91 95-9003-9003",
			alternative: "+91-80-4718-3030",
		},
	},

	// Address Information
	address: {
		full: "Settlin - Linking Spaces Technologies Pvt Ltd, Ground Floor, EBC Space 2, 19th Main Rd, Agara Village, 1st Sector, HSR Layout, Bangalore, Karnataka 560102",
		structured: {
			streetAddress: "Ground Floor, EBC Space 2, 19th Main Rd, Agara Village",
			addressLocality: "1st Sector, HSR Layout",
			addressRegion: "Karnataka",
			postalCode: "560102",
			addressCountry: "IN",
			city: "Bangalore",
		},
		googleMapsUrl: "https://maps.app.goo.gl/sd7QHzkhFJu4A3Kh7",
	},

	// Geographic Information
	geo: {
		latitude: 12.9141,
		longitude: 77.6101,
	},

	// Social Media Links
	socialMedia: {
		twitterHandle: "@settlin_in",
		facebook: "https://www.facebook.com/in.settlin",
		twitter: "https://twitter.com/settlin_in",
		linkedin: "https://www.linkedin.com/company/settlin-in",
		instagram: "https://www.instagram.com/settlin_in",
		blog: "https://settlin.in/blog",
	},

	// Business Information
	business: {
		type: "LocalBusiness",
		serviceType: "Real Estate Services",
		areaServed: "Bangalore",
		priceRange: "₹₹",
		languages: ["English", "Hindi", "Kannada"],
		openingHours: [
			{
				days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
				opens: "10:00",
				closes: "18:00",
			},
		],
	},

	// Brand Assets
	branding: {
		logo: {
			circle: "/images/logo/circle/circle-192.png",
			width: 192,
			height: 192,
		},
	},

	// Legal Information
	legal: {
		reraId: "PRM/KA/RERA/1251/446/AG/180205/001849",
		privacyPolicyLastUpdated: "30th May, 2024",
	},

	// Rating Information
	rating: {
		value: "4.6",
		count: "1000",
		bestRating: "5",
		worstRating: "1",
	},

	// Services Offered
	services: [
		{
			name: "Property Buying Services",
			description: "Expert assistance in finding and purchasing residential properties",
		},
		{
			name: "Property Selling Services",
			description: "Comprehensive property listing and selling services with no upfront charges",
		},
		{
			name: "Property Valuation",
			description: "Professional property valuation and market analysis services",
		},
		{
			name: "Legal Documentation",
			description: "Complete legal documentation support for property transactions",
		},
	],
} as const;

// Helper functions for commonly used data formats
export const getFormattedAddress = () => COMPANY_INFO.address.full;
export const getStructuredAddress = () => COMPANY_INFO.address.structured;
export const getSocialMediaLinks = () =>
	Object.values(COMPANY_INFO.socialMedia).filter(link => link.startsWith("http"));
export const getPrimaryContact = () => ({
	email: COMPANY_INFO.contact.email.primary,
	phone: COMPANY_INFO.contact.phone.primary,
});
export const getCompanyLinks = () => [
	{ label: "About us", href: "/about" },
	{ label: "Blog", href: COMPANY_INFO.socialMedia.blog },
	{ label: "FAQ", href: "/faq" },
	{ label: "Pricing", href: "/pricing" },
	{ label: "Serviceable Areas", href: "/areas" },
	{ label: "Terms of use", href: "/terms" },
	{ label: "Careers", href: `mailto:${COMPANY_INFO.contact.email.careers}` },
	{ label: "Privacy Policy", href: "/privacy-policy" },
];
